(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('Notifications', Notifications);

    Notifications.$inject = ['$resource', 'DateUtils'];

    function Notifications ($resource, DateUtils) {
        var resourceUrl =  'api/notifications/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.reviewedDate = DateUtils.convertDateTimeFromServer(data.reviewedDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAll': {url: 'api/notifications/by-employee/:employeeId', method: 'GET', isArray: true, ignoreLoadingBar: true},
            'findAllByViewed': {url: 'api/notifications/by-viewed/:viewed', method: 'GET', isArray: true},
            'findAllByCreatedDate': {url: 'api/notifications/by-createdDate/:createdDate', method: 'GET', isArray: true}
        });
    }
})();
